import { cn } from '@/lib/utils';
import type { ComponentProps } from 'react';

export const Input = ({
  className,
  type,
  ...props
}: ComponentProps<'input'>) => (
  <input type={type} data-slot="input" className={cn(className)} {...props} />
);
